import {
  Action,
  LOAD_MONITORING,
  LOAD_MONITORING_REQUEST_SUCCESS,
  LOAD_MONITORING_REQUEST_FAIL,
  UPDATE_MONITORING,
  UPDATE_SORT_BY_OPTION,
} from "./actionTypes";
import { IndexByNumber, IndexByString } from "../insights/utils";
import { SortBy } from "../../../components/Analysis/utils/types";

export interface MonitoringState {
  [key: string]:
    | boolean
    | string
    | IndexByNumber<Insite.API.Occurrence>
    | IndexByString<Array<number>>;
  hit: IndexByNumber<Insite.API.Occurrence>;
  site: IndexByString<Array<number>>;
  priority: IndexByString<Array<number>>;
  rule: IndexByString<Array<number>>;
  category: IndexByString<Array<number>>;
  siteGroups?: any /* FIXME: type */;
  composed: any /* FIXME: type */;
  sortByOption: string;
  loading: boolean;
}

const INITIAL_STATE: MonitoringState = {
  hit: {},
  site: {},
  priority: {},
  rule: {},
  category: {},
  siteGroups: false,
  composed: [],
  sortByOption: SortBy.AlphaAsc,
  loading: false,
  ready: false,
};

export function reducer(
  state: MonitoringState = INITIAL_STATE,
  action: Action
): MonitoringState {
  switch (action.type) {
    case LOAD_MONITORING:
      return {
        ...state,
        loading: true,
      };
    case LOAD_MONITORING_REQUEST_SUCCESS:
      return {
        ...state,
        ...action.result,
        loading: false,
      };
    case LOAD_MONITORING_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_MONITORING:
      return {
        ...state,
        ready: true,
        loading: false,
        siteGroups: action.siteGroups,
        composed: action.composed,
      };
    case UPDATE_SORT_BY_OPTION:
      return {
        ...state,
        sortByOption: action.sortByOption,
      };
    default:
      return state;
  }
}
